<template>
  <!-- odd 奇数 even 偶数  -->
  <div
    :class="[
      'video-play-new',
      `video-${videoList.length % 2 ? 'odd' : 'even'}`,
    ]"
  >
    <div
      :class="['video-container', isColumn ? 'video-half' : '']"
      v-for="(item, index) in videoList"
      :key="index"
    >
      <div class="video-content">
        <video
          preload
          :src="item.path || item"
          :poster="
            `${item.path ||
              item}?x-oss-process=video/snapshot,t_3000,f_png,w_0,h_0,ar_auto`
          "
        ></video>
        <div class="video-des" v-if="item && item.describe">
          {{ item.describe }}
        </div>
        <img :src="posterImg" @click="playVideo($event)" />
      </div>
    </div>
  </div>
</template>

<script>
import posterImg from "./../assets/images/wdz_pc_play_icon_20220118.png";

export default {
  name: "videoPlay",

  props: {
    videoUrl: {
      type: String,
      default: "",
    },
    videoList: {
      type: Array,
      default: () => [],
    },
    isColumn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      posterImg: posterImg,
    };
  },

  methods: {
    /**
     * 播放视频
     */
    playVideo(e) {
      e.target.parentNode.children[0].play();
      e.target.parentNode.children[0].controls = "controls";
      e.target.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.video-play-new {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .video-container {
    width: 100%;
    overflow: hidden;
    border-radius: 12px;
    margin-bottom: 16px;
    .video-content {
      position: relative;
      overflow: hidden;
      border-radius: 12px;
      .video-des {
        font-size: 13px;
        color: #999999;
        line-height: 18px;
        margin: 8px 0;
      }
      img {
        width: 54px;
        height: 54px;
        padding: 15px;
        border-radius: 50%;
        background-color: #0000004d;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
  .video-half {
    width: calc(50% - 5.5px);
  }
}
@media screen and (min-width: $maxWidth) {
  .video-play-new {
    .video-container {
      border-radius: 12px;
      margin-bottom: 16px;
      .video-content {
        border-radius: 12px;
        .video-des {
          font-size: 13px;
          color: #999999;
          line-height: 18px;
          margin: 8px 0;
        }
        img {
          width: 54px;
          height: 54px;
          padding: 15px;
        }
      }
    }
    .video-half {
      width: calc(50% - 5.5px);
    }
  }
}
</style>
